import { EgretLoadable } from 'egret';
import { authRoles } from '../../../auth/authRoles';

const UsersList = EgretLoadable({
  loader: () => import('./index')
});

const UsersListRoute = [
  {
    path: '/users-list',
    exact: true,
    component: UsersList,
    auth: authRoles.all,
  }
];

export default UsersListRoute;
